import dotenv from 'dotenv';
dotenv.config();

export const API_BASE_URL = process.env.REACT_APP_API_DOMAIN + ':'+ process.env.REACT_APP_API_PORT
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const ACCESS_TOKEN = 'accessToken';

export const OAUTH2_REDIRECT_URI = `${API_BASE_URL}/redirect?referer=http://localhost:3000/login`;

export const GOOGLE_AUTH_URL = AUTH_URL + '/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = AUTH_URL + '/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const GITHUB_AUTH_URL = AUTH_URL + '/oauth2/authorize/github?redirect_uri=' + OAUTH2_REDIRECT_URI;
